import React from 'react';
import classNames from 'classnames';
import {default as ReactSelect} from 'react-select';

import {Arrow, Description, SelectOption} from './components';

import './styles.css';
import 'react-select/dist/react-select.css';

class ImageSelect extends React.Component<any> {
  optionRenderer = option => {
    return (
      <SelectOption
        option={option}
        Description={this.props.Description || Description}
      />
    );
  };
  arrowRenderer = () => <Arrow />;

  render() {
    const {
      value,
      options,
      disabled,
      className,
      placeholder,
      onBlur,
      onChange
    } = this.props;

    return (
      <div className={classNames(className, 'ImageSelect')}>
        <ReactSelect
          className="ReactSelect"
          value={value}
          placeholder={placeholder}
          options={options}
          searchable={false}
          clearable={true}
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
          arrowRenderer={this.arrowRenderer}
          optionRenderer={this.optionRenderer}
          valueRenderer={this.optionRenderer}
        />
      </div>
    );
  }
}

export default ImageSelect;
